export default __webpack_public_path__ + "static/media/rservaOpen.fc4b53e5.jpg";